import { useEffect, useState } from 'react';
import { CardLayeredVariations } from '@marriott/mi-ui-library';
import { useGetBreakpoint } from '../../../utils/CommonUtils';

import { StyledSkeletonLoaderDiv, StyledSkeletonLoaderContainer } from './SkeletonCardCarouselLoader.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SkeletonCardCarouselLoader = (props: any) => {
  const tallCards = props?.cardType === CardLayeredVariations?.Tall;
  const wideCards = props?.cardType === CardLayeredVariations?.Wide;
  const [viewPort, setViewPort] = useState(useGetBreakpoint());
  const [totalCards, setTotalCards] = useState(
    viewPort === 'mobile' ? 1 : wideCards || viewPort === 'tablet' ? 2 : tallCards ? 3 : 3
  );

  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const getViewPort = useGetBreakpoint();
      setViewPort(getViewPort);
      setTotalCards(getViewPort === 'mobile' ? 1 : wideCards || getViewPort === 'tablet' ? 2 : tallCards ? 3 : 3);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <StyledSkeletonLoaderContainer className="container skeleton-loader-container">
      <StyledSkeletonLoaderDiv>
        {Array.from({ length: totalCards }).map((_, ind) => (
          <div className="main-wrapper" key={ind}>
            <div className="top-main-wrapper">
              <div
                className="skeleton-loader-composite img-container mb-1"
                style={
                  tallCards
                    ? {
                        height: '526px',
                        width: '330px',
                      }
                    : {
                        height: wideCards && viewPort === 'mobile' ? '265px' : '326px',
                        width: '330px',
                      }
                }
              ></div>
            </div>
          </div>
        ))}
      </StyledSkeletonLoaderDiv>
    </StyledSkeletonLoaderContainer>
  );
};
